module.exports = __webpack_public_path__ + "img/7_31.2b3b2f96.png";